import React from 'react';
import { AnimatedIcon } from '@shell-b2c/web-design-system';

export const LockAnimation = (props) => {
  return <AnimatedIcon type="lock" {...props} />;
};

export default LockAnimation;
